import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Auth/Login';
import Signup from './pages/Auth/Signup';
import ProfileSetup from './pages/Profile/ProfileSetup';
import MenteeDashboard from './pages/Dashboard/MenteeDashboard';
import MentorDashboard from './pages/Dashboard/MentorDashboard';
import GoalTracker from './pages/Goals/GoalTracker';
import MatchingFlow from './pages/Matching/MatchingFlow';
import MessagingHub from './pages/Messaging/MessagingHub';
import ResourceHub from './pages/Community/ResourceHub';
import VerificationFlow from './pages/Verification/VerificationFlow';
import Layout from './components/Layout';
import MenteeGoals from './pages/Goals/MenteeGoals';
import MentorGoals from './pages/Goals/MentorGoals';
import MenteeMatching from './pages/Matching/MenteeMatching';
import MentorMatching from './pages/Matching/MentorMatching';
import MenteeResourceHub from './pages/Community/MenteeResourceHub';
import MentorResourceHub from './pages/Community/MentorResourceHub';
import Trophies from './pages/Profile/Trophies';
import Profile from './pages/Profile/Profile';
import WorkInProgress from './pages/WorkInProgress';
import SupportBuddyPage from './pages/Settings/SupportBuddyPage';
import MentorHub from './pages/MentorHub/MentorHub';
export function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userType, setUserType] = useState<'mentor' | 'mentee' | null>(null);
  const [profileComplete, setProfileComplete] = useState(false);
  useEffect(() => {
    const userData = localStorage.getItem('userData');
    if (userData) {
      const {
        userType,
        profileComplete
      } = JSON.parse(userData);
      setIsAuthenticated(true);
      setUserType(userType);
      setProfileComplete(profileComplete || false);
    }
  }, []);
  const handleSignup = (type: 'mentor' | 'mentee', skipProfileSetup = false) => {
    setIsAuthenticated(true);
    setUserType(type);
    setProfileComplete(skipProfileSetup);
    // Save initial user data
    localStorage.setItem('userData', JSON.stringify({
      userType: type,
      profileComplete: skipProfileSetup,
      profile: {},
      // Add demo data for testing
      mentor: {
        impactMetrics: {
          activeEngagements: 0,
          totalMentees: 0,
          sessionHours: 0,
          completedGoals: 0
        }
      }
    }));
  };
  const handleLogin = (type: 'mentor' | 'mentee', skipProfileSetup = false) => {
    setIsAuthenticated(true);
    setUserType(type);
    setProfileComplete(skipProfileSetup);
  };
  const handleProfileComplete = () => {
    setProfileComplete(true);
    const userData = localStorage.getItem('userData');
    if (userData) {
      const parsed = JSON.parse(userData);
      localStorage.setItem('userData', JSON.stringify({
        ...parsed,
        profileComplete: true
      }));
    }
  };
  const handleLogout = () => {
    setIsAuthenticated(false);
    setUserType(null);
    setProfileComplete(false);
    localStorage.removeItem('userData');
  };
  const handleUserTypeChange = (type: 'mentor' | 'mentee') => {
    setUserType(type);
  };
  return <Router data-id="element-0">
      <div className="w-full min-h-screen bg-gray-50" data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={!isAuthenticated ? <Signup onSignup={handleSignup} data-id="element-4" /> : !profileComplete ? <Navigate to="/profile-setup" data-id="element-5" /> : <Navigate to={userType === 'mentor' ? '/mentor-dashboard' : '/mentee-dashboard'} data-id="element-6" />} data-id="element-3" />
          <Route path="/login" element={!isAuthenticated ? <Login onLogin={handleLogin} data-id="element-8" /> : !profileComplete ? <Navigate to="/profile-setup" data-id="element-9" /> : <Navigate to={userType === 'mentor' ? '/mentor-dashboard' : '/mentee-dashboard'} data-id="element-10" />} data-id="element-7" />
          <Route path="/profile-setup" element={isAuthenticated ? <ProfileSetup userType={userType} onComplete={handleProfileComplete} data-id="element-12" /> : <Navigate to="/" data-id="element-13" />} data-id="element-11" />
          <Route path="/mentee-dashboard" element={isAuthenticated && profileComplete && userType === 'mentee' ? <Layout userType={userType} onLogout={handleLogout} data-id="element-15">
                  <MenteeDashboard data-id="element-16" />
                </Layout> : <Navigate to="/" data-id="element-17" />} data-id="element-14" />
          <Route path="/mentor-dashboard" element={isAuthenticated && profileComplete && userType === 'mentor' ? <Layout userType={userType} onLogout={handleLogout} data-id="element-19">
                  <MentorDashboard data-id="element-20" />
                </Layout> : <Navigate to="/" data-id="element-21" />} data-id="element-18" />
          <Route path="/mentor-hub" element={isAuthenticated && profileComplete ? <Layout userType={userType} onLogout={handleLogout} data-id="element-23">
                  <Navigate to="/mentor-hub/goals" replace data-id="element-24" />
                </Layout> : <Navigate to="/" data-id="element-25" />} data-id="element-22" />
          <Route path="/mentor-hub/:tab" element={isAuthenticated && profileComplete ? <Layout userType={userType} onLogout={handleLogout} data-id="element-27">
                  <MentorHub userType={userType} data-id="element-28" />
                </Layout> : <Navigate to="/" data-id="element-29" />} data-id="element-26" />
          <Route path="/goals" element={isAuthenticated && profileComplete ? <Navigate to="/mentor-hub/goals" replace data-id="element-31" /> : <Navigate to="/" data-id="element-32" />} data-id="element-30" />
          <Route path="/matching" element={isAuthenticated && profileComplete ? <Navigate to="/mentor-hub/matching" replace data-id="element-34" /> : <Navigate to="/" data-id="element-35" />} data-id="element-33" />
          <Route path="/messages" element={isAuthenticated && profileComplete ? <Navigate to="/mentor-hub/messages" replace data-id="element-37" /> : <Navigate to="/" data-id="element-38" />} data-id="element-36" />
          <Route path="/resources" element={isAuthenticated && profileComplete ? <Layout userType={userType} onLogout={handleLogout} data-id="element-40">
                  {userType === 'mentor' ? <MentorResourceHub userType={userType} data-id="element-41" /> : <MenteeResourceHub userType={userType} data-id="element-42" />}
                </Layout> : <Navigate to="/" data-id="element-43" />} data-id="element-39" />
          <Route path="/verify" element={isAuthenticated && userType ? <VerificationFlow userType={userType} data-id="element-45" /> : <Navigate to="/" data-id="element-46" />} data-id="element-44" />
          <Route path="/trophies" element={isAuthenticated && profileComplete ? <Layout userType={userType} onLogout={handleLogout} data-id="element-48">
                  <Trophies data-id="element-49" />
                </Layout> : <Navigate to="/" data-id="element-50" />} data-id="element-47" />
          <Route path="/profile" element={isAuthenticated && profileComplete ? <Layout userType={userType} onLogout={handleLogout} data-id="element-52">
                  <Profile userType={userType} onUserTypeChange={handleUserTypeChange} data-id="element-53" />
                </Layout> : <Navigate to="/" data-id="element-54" />} data-id="element-51" />
          <Route path="/settings" element={isAuthenticated && profileComplete ? <Layout userType={userType} onLogout={handleLogout} data-id="element-56">
                  <WorkInProgress data-id="element-57" />
                </Layout> : <Navigate to="/" data-id="element-58" />} data-id="element-55" />
          <Route path="/security" element={isAuthenticated && profileComplete ? <Layout userType={userType} onLogout={handleLogout} data-id="element-60">
                  <WorkInProgress data-id="element-61" />
                </Layout> : <Navigate to="/" data-id="element-62" />} data-id="element-59" />
          <Route path="/help" element={isAuthenticated && profileComplete ? <Layout userType={userType} onLogout={handleLogout} data-id="element-64">
                  <WorkInProgress data-id="element-65" />
                </Layout> : <Navigate to="/" data-id="element-66" />} data-id="element-63" />
          <Route path="/settings/support-buddy" element={isAuthenticated && profileComplete ? <Layout userType={userType} onLogout={handleLogout} data-id="element-68">
                  <SupportBuddyPage userType={userType} data-id="element-69" />
                </Layout> : <Navigate to="/" data-id="element-70" />} data-id="element-67" />
          <Route path="*" element={<WorkInProgress data-id="element-72" />} data-id="element-71" />
        </Routes>
      </div>
    </Router>;
}